<form [formGroup]="formGroupInput">
  <ng-template
    #recursiveListGroup
    let-inputContentGroups
    let-formGroup="formGroup"
  >
    <div
      class="card"
      *ngFor="let inputContentGroup of inputContentGroups; let i = index"
    >
      <strong
        class="pt-3 ps-3"
        *ngIf="inputContentGroup.inputContentGroupTitle"
        >{{ inputContentGroup.inputContentGroupTitle }}</strong
      >
      <div
        class="ps-3 pt-1"
        style="white-space: pre-line"
        *ngIf="inputContentGroup.inputContentGroupDescription"
      >
        {{ inputContentGroup.inputContentGroupDescription }}
      </div>
      <div class="card-body">
        <ng-container
          *ngTemplateOutlet="
            recursiveListInputContent;
            context: {
              $implicit: inputContentGroup.inputContents,
              formGroup: formGroupInput.controls[inputContentGroup.uuid]
            }
          "
        >
        </ng-container>
      </div>
    </div>
  </ng-template>
  <!-- InputContents -->
  <ng-template
    #recursiveListInputContent
    let-inputContents
    let-formGroup="formGroup"
  >
    <client-form-input-content-list
      [inputContents]="inputContents"
      [formGroup]="formGroup"
    >
    </client-form-input-content-list>
  </ng-template>
  <ng-container
    *ngTemplateOutlet="
      recursiveListGroup;
      context: { $implicit: inputContentGroupList }
    "
  >
  </ng-container>
</form>
